import { RefundBody } from '@models/paymentStatement';
import { apiClient } from '.';
import { ChangeScheduleBody } from './paymentStatements';

export const handleRefund = async (data: { orderId: string; body: RefundBody }) => {
  return apiClient.post(`/partner/v1/sales-channels/${data.orderId}/refund/${data.body.type}`, data.body);
};

export const changePlannedDate = async (data: ChangeScheduleBody) => {
  return apiClient.patch(`/partner/v1/sales-channels/${data.salesChannelOrderId}/planned-date`, data.body);
};
